module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Kl4COD/tc-custom/9781646560318.jpg?1723374916640",
      "alt": "This image is the cover for the book Being Fitz"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Being Fitz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Lysander \"Fitz\" Fitzgibbon used to teach at a university, but quit when his father grew ill and needed someone to take care of him. Years later, after his dad's death, Fitz has given up on his dreams, drives a bus route, and endures visits from Jerry, who can't really be called a friend, and barely a benefit. Fitz is lonely, worries about his weight, and figures life won't be getting any better."), _c('br'), _c('br'), _vm._v("Then, Fitz stumbles over a dead body in the park. As if life couldn't get any worse, he has a run-in with Detective Holland Simms, whose infuriating arrogance and brash behavior provokes Fitz to punch him. But strangely enough, Fitz feels more alive around Simms than he has in a long time, though he finds it hard to believe that the confident Simms would want anything to do with him. Should he take a chance on more?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J.D. Walker\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0